import script from "./DictionaryItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DictionaryItem.vue?vue&type=script&setup=true&lang=js"

import "./DictionaryItem.vue?vue&type=style&index=0&id=74ba4e0a&lang=css"
import "./DictionaryItem.vue?vue&type=style&index=1&id=74ba4e0a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74ba4e0a"]])

export default __exports__